"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdResponseToJSON = exports.AdResponseFromJSONTyped = exports.AdResponseFromJSON = exports.instanceOfAdResponse = void 0;
var runtime_1 = require("../runtime");
var AdCallToActionResponse_1 = require("./AdCallToActionResponse");
var AdResponseAssets_1 = require("./AdResponseAssets");
var AdStatus_1 = require("./AdStatus");
var AdThirdPartyTracking_1 = require("./AdThirdPartyTracking");
var DeliveryResponse_1 = require("./DeliveryResponse");
var Placement_1 = require("./Placement");
var SlotPositionsInner_1 = require("./SlotPositionsInner");
/**
 * Check if a given object implements the AdResponse interface.
 */
function instanceOfAdResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdResponse = instanceOfAdResponse;
function AdResponseFromJSON(json) {
    return AdResponseFromJSONTyped(json, false);
}
exports.AdResponseFromJSON = AdResponseFromJSON;
function AdResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'callToAction': !(0, runtime_1.exists)(json, 'call_to_action') ? undefined : (0, AdCallToActionResponse_1.AdCallToActionResponseFromJSON)(json['call_to_action']),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'delivery': !(0, runtime_1.exists)(json, 'delivery') ? undefined : (0, DeliveryResponse_1.DeliveryResponseFromJSON)(json['delivery']),
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AdStatus_1.AdStatusFromJSON)(json['status']),
        'rejectReason': !(0, runtime_1.exists)(json, 'reject_reason') ? undefined : json['reject_reason'],
        'adPreviewUrl': !(0, runtime_1.exists)(json, 'ad_preview_url') ? undefined : json['ad_preview_url'],
        'placements': !(0, runtime_1.exists)(json, 'placements') ? undefined : (json['placements'].map(Placement_1.PlacementFromJSON)),
        'advertiserName': !(0, runtime_1.exists)(json, 'advertiser_name') ? undefined : json['advertiser_name'],
        'assets': !(0, runtime_1.exists)(json, 'assets') ? undefined : (0, AdResponseAssets_1.AdResponseAssetsFromJSON)(json['assets']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'tagline': !(0, runtime_1.exists)(json, 'tagline') ? undefined : json['tagline'],
        'thirdPartyTracking': !(0, runtime_1.exists)(json, 'third_party_tracking') ? undefined : (json['third_party_tracking'].map(AdThirdPartyTracking_1.AdThirdPartyTrackingFromJSON)),
        'slotPositions': !(0, runtime_1.exists)(json, 'slot_positions') ? undefined : (json['slot_positions'].map(SlotPositionsInner_1.SlotPositionsInnerFromJSON)),
        'notaryMetadata': !(0, runtime_1.exists)(json, 'notary_metadata') ? undefined : json['notary_metadata'],
        'dvClientCode': !(0, runtime_1.exists)(json, 'dv_client_code') ? undefined : json['dv_client_code'],
        'assetUri': !(0, runtime_1.exists)(json, 'asset_uri') ? undefined : json['asset_uri'],
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
    };
}
exports.AdResponseFromJSONTyped = AdResponseFromJSONTyped;
function AdResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'call_to_action': (0, AdCallToActionResponse_1.AdCallToActionResponseToJSON)(value.callToAction),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'delivery': (0, DeliveryResponse_1.DeliveryResponseToJSON)(value.delivery),
        'ad_set_id': value.adSetId,
        'status': (0, AdStatus_1.AdStatusToJSON)(value.status),
        'reject_reason': value.rejectReason,
        'ad_preview_url': value.adPreviewUrl,
        'placements': value.placements === undefined ? undefined : (value.placements.map(Placement_1.PlacementToJSON)),
        'advertiser_name': value.advertiserName,
        'assets': (0, AdResponseAssets_1.AdResponseAssetsToJSON)(value.assets),
        'name': value.name,
        'tagline': value.tagline,
        'third_party_tracking': value.thirdPartyTracking === undefined ? undefined : (value.thirdPartyTracking.map(AdThirdPartyTracking_1.AdThirdPartyTrackingToJSON)),
        'slot_positions': value.slotPositions === undefined ? undefined : (value.slotPositions.map(SlotPositionsInner_1.SlotPositionsInnerToJSON)),
        'notary_metadata': value.notaryMetadata,
        'dv_client_code': value.dvClientCode,
        'asset_uri': value.assetUri,
        'ad_account_id': value.adAccountId,
    };
}
exports.AdResponseToJSON = AdResponseToJSON;
